<template>
  <div @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave" class="z-7">
    <Button variant="overlay" size="compact" @click="handleButtonZoom">
      <template #start>
        <icon />
      </template>
    </Button>
  </div>
</template>

<script setup lang="ts">
import { useMouseZoom } from "@/composables/mouse_zoom";
import { UseZoomableReturnType } from "@/composables/zoomable";
import { useEditorStore } from "@/stores/editor_store";
import Konva from "konva";
import { Button, ZoomInIcon, ZoomOutIcon } from "prism";
import { computed, Ref } from "vue";

const props = defineProps<{
  zoomable: UseZoomableReturnType;
  stage: Ref<Konva.Stage>;
}>();

const store = useEditorStore();

const icon = computed(() => {
  return props.zoomable.zoomCursorType.value === "zoom-in" ? ZoomInIcon : ZoomOutIcon;
});

const { handleButtonZoom } = useMouseZoom(props.zoomable, props.stage);

const handleMouseEnter = () => {
  store.isHoveringZoomButton = true;
};

const handleMouseLeave = () => {
  store.isHoveringZoomButton = false;
};
</script>

<style scoped>
.z-7 {
  z-index: 7;
}
</style>
